<template>
  <!-- 效果评估报告编写审核 -->
  <div>
    <el-form ref="applyForm2" :model="addFrom" class="xgpg_audit_form">
      <div class="xgpg_audit_wrap">
        <el-row>
          <transition name="fade">
            <el-table
              v-show="fileListShow"
              :data="xgpg.auditData.files"
              fit
              size="mini"
              border
              stripe
              :header-cell-style="tableHeaderColor"
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="操作"
                prop="xmmc"
                min-width="100px"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    @click="handleDownloadFile(scope.row)"
                    style="color: #036eb8; cursor: pointer"
                    >下载</span
                  >
                  <span
                    @click="handleViewFile(scope.row)"
                    style="color: #036eb8; margin: 0 15px; cursor: pointer"
                    >预览</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="文件名字"
                prop="fileName"
                min-width="200px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="文件类型"
                prop="fileType"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="文件大小"
                prop="fileSize"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <div>
                    {{ (scope.row.fileSize / 1024 / 1024).toFixed(2) }}M
                  </div>
                </template></el-table-column
              >
              <el-table-column
                label="上传人"
                prop="uploader"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="上传时间"
                prop="uploadTime"
                min-width="80px"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </transition>
        </el-row>
        <el-row style="padding-bottom: 10px; margin-top: 10px">
          <el-col :span="12">
            <span style="color: #f56c6c; position: absolute; top: 15px">*</span>
            <el-form-item
              label="关联任务"
              prop="linkTaskId"
              style="padding-left: 7px"
            >
              <el-select
                v-model="xgpg.auditData.v7"
                filterable
                default-first-option
                style="width: calc(100% - 100px)"
                @change="handleChangeTask"
                disabled
              >
                <el-option
                  v-for="item in linkList"
                  :key="item.task_id + ''"
                  :label="item.plan_name"
                  :value="item.task_id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="评估类型" prop="type">
              <el-tooltip
                class="item"
                effect="dark"
                content="根据评审通过的效果评估策略选择的评估类型进行自动填充，无须选择；如未显示内容，请先进行并完成效果评估策略制定工作。"
                placement="right"
                disabled
              >
                <el-select
                  v-model="xgpg.auditData.v6"
                  disabled
                  style="width: calc(100% - 100px)"
                >
                  <el-option
                    v-for="item in this.pglxList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="scroll_row">
          <div>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>1.结构内容</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.auditData.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="列明每部分内容页数:(1) 首次评估: 历程、成效、不足、方案和计划 (2) 半年评估: 成效、不足、方案和计划 (3) 年度评估、提升评估: 成效目标、差距、方案和计划 (4) 续约评估: 成效、目标、差距、规划和计划 (5) 一把手变更评估: 一把手要求、差距、方案和计划 (6) 专题评估: 问题分析、方案和计划"
                  v-model="xgpg.auditData.v1"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  type="textarea"
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="列明每部分内容页数:(1) 首次评估: 历程、成效、不足、方案和计划 (2) 半年评估: 成效、不足、方案和计划 (3) 年度评估、提升评估: 成效目标、差距、方案和计划 (4) 续约评估: 成效、目标、差距、规划和计划 (5) 一把手变更评估: 一把手要求、差距、方案和计划 (6) 专题评估: 问题分析、方案和计划"
                  v-model="xgpg.auditData.fgsReview.v1"
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.zxbReview.xm
                    ? `咨询管理部(${xgpg.auditData.zxbReview.xm})`
                    : '咨询部'
                "
                v-if="
                  xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                "
              >
                <el-input
                  type="textarea"
                  :disabled="xgpg.auditData.isReview != 2"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="列明每部分内容页数:(1) 首次评估: 历程、成效、不足、方案和计划 (2) 半年评估: 成效、不足、方案和计划 (3) 年度评估、提升评估: 成效目标、差距、方案和计划 (4) 续约评估: 成效、目标、差距、规划和计划 (5) 一把手变更评估: 一把手要求、差距、方案和计划 (6) 专题评估: 问题分析、方案和计划"
                  v-model="xgpg.auditData.zxbReview.v1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>2.列明亮点</div>
                <div @click="handleShowHistory">过往评估报告亮点</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.auditData.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: (1) 首次评估: 建设期亮点;年内工作设置是否能秀实管理基础 (2) 半年评估: 半年成效;下半年纠偏强化举措是否有利于全年目标实现(3) 年度评估、提升评估: 今年成效;绩效方案是否有利于明年目标实现 (4) 续约评估: 历年成效绩效规划是否有利于未来中长期发展目标的实现(5) 一把手变更评估: 满足一把手工作要求的方突出天维公司不可替代的价值(6) 专题评估:绩效方案是否有解决问题，降低咨询风险"
                  v-model="xgpg.auditData.v2"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  type="textarea"
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: (1) 首次评估: 建设期亮点;年内工作设置是否能秀实管理基础 (2) 半年评估: 半年成效;下半年纠偏强化举措是否有利于全年目标实现(3) 年度评估、提升评估: 今年成效;绩效方案是否有利于明年目标实现 (4) 续约评估: 历年成效绩效规划是否有利于未来中长期发展目标的实现(5) 一把手变更评估: 满足一把手工作要求的方突出天维公司不可替代的价值(6) 专题评估:绩效方案是否有解决问题，降低咨询风险"
                  v-model="xgpg.auditData.fgsReview.v2"
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.zxbReview.xm
                    ? `咨询管理部(${xgpg.auditData.zxbReview.xm})`
                    : '咨询部'
                "
                v-if="
                  xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                "
              >
                <el-input
                  :disabled="xgpg.auditData.isReview != 2"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: (1) 首次评估: 建设期亮点;年内工作设置是否能秀实管理基础 (2) 半年评估: 半年成效;下半年纠偏强化举措是否有利于全年目标实现(3) 年度评估、提升评估: 今年成效;绩效方案是否有利于明年目标实现 (4) 续约评估: 历年成效绩效规划是否有利于未来中长期发展目标的实现(5) 一把手变更评估: 满足一把手工作要求的方突出天维公司不可替代的价值(6) 专题评估:绩效方案是否有解决问题，降低咨询风险"
                  v-model="xgpg.auditData.zxbReview.v2"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>3.计划是否清晰</div>
              </div>
              <div>
                <el-checkbox v-model="xgpg.auditData.v3" disabled
                  >是</el-checkbox
                >
              </div>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: (1)首次评估: 是否有利于实绩效管理基础 (2) 半年评估: 是否纠偏或强化了绩效管理，有利于价值目标实现 (3) 年度评估、提升评估: 是否能支撑明年目标的实现 (4)续约评估:规划是否按照续约表模板制定，内容是否有效解决痛点问题，是否有利于实现目标 (5) 一把手变更评估:是否充分体现天维公司不可替代的价值 (6) 专题评估: 方案是否能有效解决问题，并降低咨询风险"
                  v-model="xgpg.auditData.fgsReview.v3"
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.zxbReview.xm
                    ? `咨询管理部(${xgpg.auditData.zxbReview.xm})`
                    : '咨询部'
                "
                v-if="
                  xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                "
              >
                <el-input
                  :disabled="xgpg.auditData.isReview != 2"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: (1)首次评估: 是否有利于实绩效管理基础 (2) 半年评估: 是否纠偏或强化了绩效管理，有利于价值目标实现 (3) 年度评估、提升评估: 是否能支撑明年目标的实现 (4)续约评估:规划是否按照续约表模板制定，内容是否有效解决痛点问题，是否有利于实现目标 (5) 一把手变更评估:是否充分体现天维公司不可替代的价值 (6) 专题评估: 方案是否能有效解决问题，并降低咨询风险"
                  v-model="xgpg.auditData.zxbReview.v3"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>4.报告主要逻辑</div>
              </div>
              <el-form-item :label="`咨询师(${xgpg.auditData.xm})`">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: 一句话说明报告主要逻辑，如果跟策略一致，复用策略主题"
                  v-model="xgpg.auditData.v4"
                  disabled
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: 一句话说明报告主要逻辑，如果跟策略一致，复用策略主题"
                  v-model="xgpg.auditData.fgsReview.v4"
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.zxbReview.xm
                    ? `咨询管理部(${xgpg.auditData.zxbReview.xm})`
                    : '咨询部'
                "
                v-if="
                  xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                "
              >
                <el-input
                  :disabled="xgpg.auditData.isReview != 2"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: 一句话说明报告主要逻辑，如果跟策略一致，复用策略主题"
                  v-model="xgpg.auditData.zxbReview.v4"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div>
                  <span>*</span>5.分析是否正文分析只用于论证，不作为主要内容
                </div>
              </div>
              <div>
                <el-checkbox v-model="xgpg.auditData.v5" disabled
                  >是</el-checkbox
                >
              </div>
              <el-form-item
                :label="
                  xgpg.auditData.fgsReview.xm
                    ? `分公司(${xgpg.auditData.fgsReview.xm})`
                    : '分公司'
                "
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: 正文分析只用于论证，不作为主要内容"
                  v-model="xgpg.auditData.fgsReview.v5"
                  :disabled="
                    xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                  "
                />
              </el-form-item>
              <el-form-item
                :label="
                  xgpg.auditData.zxbReview.xm
                    ? `咨询管理部(${xgpg.auditData.zxbReview.xm})`
                    : '咨询部'
                "
                v-if="
                  xgpg.auditData.isReview == 2 || xgpg.auditData.isReview == 3
                "
              >
                <el-input
                  :disabled="xgpg.auditData.isReview != 2"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="800"
                  show-word-limit
                  placeholder="评价标准: 正文分析只用于论证，不作为主要内容"
                  v-model="xgpg.auditData.zxbReview.v5"
                />
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="this.title"
      :visible.sync="historyDialog"
      width="80%"
      v-if="historyDialog"
      append-to-body
      id="history-dialog"
    >
      <div v-if="historyList && historyList.length > 0">
        <div v-for="(item, index) in historyList" :key="index">
          <div class="history_row">
            <div>申请日期： {{ item.createtime }}</div>
            <div>申请人： {{ item.xm }}</div>
          </div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 6 }"
              placeholder="请输入备注"
              disabled
              v-model="item.nr"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        style="
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #999;
        "
      >
        <img src="@/img/nodata.png" alt="" width="240" />
        <div>暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="historyDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="评审结果确认"
      :visible.sync="adviceDialog"
      width="80%"
      v-if="adviceDialog"
      append-to-body
    >
      <div>
        <div class="advice_row">
          <div>整体意见</div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 20 }"
              placeholder="请输入整体意见"
              disabled
              v-model="addFrom.advice"
            />
          </div>
        </div>
      </div>
      <div
        class="advice_row"
        v-if="xgpg.auditData.isReview == 2 && status != 2"
      >
        <div><span style="color: #f56c6c">*</span>质量评价</div>
        <div>
          <el-radio-group v-model="evaluation" size="small">
            <el-radio label="3">优秀</el-radio>
            <el-radio label="2">良好</el-radio>
            <el-radio label="1">一般</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">确 认</el-button>
        <el-button @click="adviceDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDict } from "@/api/common.js";
import { getLinkTask, getZxpsGw, saveAuditData } from "@/api/xgpg.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
export default {
  name: "audit",
  computed: {
    ...mapGetters(["deptUser", "xgpg"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      historyDialog: false,
      historyList: [],
      adviceDialog: false,
      addFrom: {
        advice: null,
      },
      rules: {},
      pglxList: [],
      status: null,
      parentDialog: false,
      fileListShow: true,
      linkList: [],
      evaluation: null,
      canSubmit: true,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("xgpg/fetchAuditDataAction", {
      applyId: this.mxParams.applyId,
    });

    Promise.all([
      this.getLinkTaskData(),
      this.getAssessTypeData(),
      this.getData(),
    ]).then(() => {
      this.handleChangeTask(this.xgpg.applyData2.v7);
    });
  },
  methods: {
    getData() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("xgpg/fetchAuditDataAction", {
            applyId: this.mxParams.applyId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.fileNum = res.data.files ? 3 - res.data.files.length : 3;
              this.mxParams.status = res.data.status;
              this.mxParams.isExecutor = res.data.isExecutor;
              this.setValue(this.mxParams);
            }
            resolve();
          });
      });
    },
    getLinkTaskData() {
      return new Promise((resolve, reject) => {
        getLinkTask({ taskId: this.mxParams.taskId, type: 1 }).then((res) => {
          if (res.code == 0) {
            this.linkList = res.data;
            resolve();
          }
        });
      });
    },

    getAssessTypeData() {
      return new Promise((resolve, reject) => {
        getDict("assess_type", 1).then((res) => {
          if (res.code == 0) {
            this.pglxList = res.data;
            resolve();
          }
        });
      });
    },
    handleChangeTask(e) {
      for (let i of this.linkList) {
        if (i.task_id == e) {
          this.xgpg.applyData2.type = i.type;
          break;
        }
      }
      this.$forceUpdate();
    },
    handleShowAdvice(e) {
      this.status = e;
      if (this.xgpg.auditData.isReview == 2) {
        this.addFrom.advice = `结构内容：${
          this.xgpg.auditData.zxbReview.v1
            ? this.xgpg.auditData.zxbReview.v1
            : "暂无"
        }。\n

列明亮点：${
          this.xgpg.auditData.zxbReview.v2
            ? this.xgpg.auditData.zxbReview.v2
            : "暂无"
        }。\n

计划是否清晰：${
          this.xgpg.auditData.zxbReview.v3
            ? this.xgpg.auditData.zxbReview.v3
            : "暂无"
        }。\n

报告主要逻辑：${
          this.xgpg.auditData.zxbReview.v4
            ? this.xgpg.auditData.zxbReview.v4
            : "暂无"
        }。\n

分析是否正文分析只用于论证，不作为主要内容：${
          this.xgpg.auditData.zxbReview.v5
            ? this.xgpg.auditData.zxbReview.v5
            : "暂无"
        }\n`;
      } else if (this.xgpg.auditData.isReview == 1) {
        this.addFrom.advice = `结构内容：${
          this.xgpg.auditData.fgsReview.v1
            ? this.xgpg.auditData.fgsReview.v1
            : "暂无"
        }\n
列明亮点：${
          this.xgpg.auditData.fgsReview.v2
            ? this.xgpg.auditData.fgsReview.v2
            : "暂无"
        }\n
计划是否清晰：${
          this.xgpg.auditData.fgsReview.v3
            ? this.xgpg.auditData.fgsReview.v3
            : "暂无"
        }\n
报告主要逻辑：${
          this.xgpg.auditData.fgsReview.v4
            ? this.xgpg.auditData.fgsReview.v4
            : "暂无"
        }\n
分析是否正文分析只用于论证，不作为主要内容：${
          this.xgpg.auditData.fgsReview.v5
            ? this.xgpg.auditData.fgsReview.v5
            : "暂无"
        }\n`;
      }
      this.adviceDialog = true;
      this.evaluation = null;
    },
    handleSave() {
      const { isReview, fgsReview, zxbReview, id, jdName, taskId } =
        this.xgpg.auditData;
      if (
        !this.evaluation &&
        this.xgpg.auditData.isReview == 2 &&
        this.status == 1
      ) {
        this.$message.error("请选择质量评价！");
        return;
      }
      let data = {
        applyId: this.mxParams.applyId,
        status: this.status,
        process: isReview,
        id,
        jdName,
        taskId,
        v1: isReview == 1 ? fgsReview.v1 : zxbReview.v1,
        v2: isReview == 1 ? fgsReview.v2 : zxbReview.v2,
        v3: isReview == 1 ? fgsReview.v3 : zxbReview.v3,
        v4: isReview == 1 ? fgsReview.v4 : zxbReview.v4,
        v5: isReview == 1 ? fgsReview.v5 : zxbReview.v5,
        evaluation: this.evaluation,
      };
      if (isReview == 2) {
        data.reviewCount = this.xgpg.auditData.reviewCount;
      }
      if (this.canSubmit) {
        this.canSubmit = false;
        saveAuditData(data).then((res) => {
          this.canSubmit = true;

          if (res.code == 0) {
            this.$message.success(res.msg);
            this.adviceDialog = false;
            this.$emit("giveFather", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleShowHistory() {
      this.historyDialog = true;
      const data = {
        taskId: this.mxParams.taskId,
        linkPoint: this.mxParams.linkPoint,
        page: 1,
        pageSize: 100,
      };
      getZxpsGw(data).then((res) => {
        if (res.code == 0) {
          this.historyList = res.data.zxpsGw;
          this.title = res.data.title;
        }
      });
    },

    setValue() {
      this.$emit("getValue", this.mxParams); //触发transfer方法，this.value为向父组件传递的数据
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleDownloadFile(row) {
      const filePath = row.absolutePath;
      const fileName = row.fileName;
      let url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;

      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleViewFile(row) {
      const url = row.serverPath;
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
.scroll_row {
  max-height: 500px;
  overflow: auto;
  width: calc(100% + 20px);
  padding: 15px 30px 0 0;
  border-top: 1px solid #dcdfe6;
  .row_title {
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    div:nth-of-type(1) {
      text-align: right;
    }
    div:nth-of-type(2) {
      color: #036eb8;
      cursor: pointer;
    }
    span {
      color: #f56c6c;
    }
  }
}
.history_row {
  display: flex;
  div {
    margin-right: 30px;
    line-height: 44px;
  }
}
.advice_row {
  display: flex;
  width: 100%;
  margin-top: 30px;
  > div:nth-of-type(1) {
    width: 70px;
  }
  > div:nth-of-type(2) {
    width: calc(100% - 70px);
  }
}
::v-deep.xgpg_audit_form .el-form-item {
  margin-bottom: 0;
}
</style>